import type { DocumentsState } from './types';

export const initialDocumentsState: DocumentsState = {
  documents: {},
  documentsProgress: {},
  fetchDocumentDownloadUrlError: '',
  fetchDocumentDownloadUrlLoading: false
};
